import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-navbar-actions" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "search-button-content" }
const _hoisted_4 = { class: "search-button-text" }
const _hoisted_5 = { class: "search-button-shortcut" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search search-button-icon" }, null, -1)

import { reactive, computed } from "vue";
import { useStore } from "vuex";
import { useGlobalSearch } from "@/composable/useGlobalSearch";
// import LanguageDropdown from "@/components/navbar/components/dropdowns/LanguageDropdown.vue";
import ProfileDropdown from "@/components/navbar/components/dropdowns/ProfileDropdown.vue";

interface AppNavbarActionsState {
  userName: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

// Initialize global search
const { open: openGlobalSearch } = useGlobalSearch();

// Detect if running on Mac
const isMac = computed(() => {
  return (
    typeof navigator !== "undefined" &&
    navigator.platform.toUpperCase().indexOf("MAC") >= 0
  );
});

const state: AppNavbarActionsState = reactive({
  userName: computed((): string => store.state.auth.user.name)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "app-navbar-actions__item app-navbar-actions__search-button search-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openGlobalSearch) && _unref(openGlobalSearch)(...args))),
      title: _ctx.$t('globalSearch.searchShortcut')
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("buttons.search")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(isMac) ? "⌘K" : "Ctrl+K"), 1)
      ]),
      _hoisted_6
    ], 8, _hoisted_2),
    _createVNode(ProfileDropdown, { class: "app-navbar-actions__item app-navbar-actions__item--profile" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(state).userName), 1)
      ]),
      _: 1
    })
  ]))
}
}

})